import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getApplicationReviews } from 'services/apiKYP'
import Colors from 'utils/Colors'
import { APPLICATION_RESULT } from 'utils/constants/application'
import { FindInPage } from '@mui/icons-material'
import { Button, Notification } from './styles'
import { REVIEW_STATUS } from '../../../utils/constants/kypStatuses'

const OpenApplicationButton = (props) => {
  const { applicationData, onClick } = props
  const id = applicationData.uuid
  const [notificationsNumber, setNotificationsNumber] = useState(0)
  const [waitingReview, setWaitingReview] = useState(false)
  const token = useSelector((state) => state.auth.access_token)

  const countPendingReviews = (reviews) => {
    return reviews.filter((review) => review.status === REVIEW_STATUS.AWAITING_DECISION).length
  }

  const getPossibleActions = useCallback(async () => {
    if (waitingReview) {
      getApplicationReviews(token, id)
        .then((response) => {
          setNotificationsNumber(countPendingReviews(response?.data))
        })
        .catch(() => {
          setNotificationsNumber(0)
        })
        .finally(() => {})
    }
  }, [waitingReview])

  useEffect(() => {
    getPossibleActions()
  }, [getPossibleActions])

  useEffect(() => {
    const isWaitingReview = () => {
      const bgcSummary = applicationData.background_check
      if (
        !applicationData?.result ||
        applicationData?.result === APPLICATION_RESULT.waitingForReview
      ) {
        if (
          applicationData?.status === APPLICATION_RESULT.waitingReview ||
          (bgcSummary?.is_score_inconsistent &&
            bgcSummary?.score_result === APPLICATION_RESULT.waitingReview)
        )
          return true
      }
      return false
    }
    setWaitingReview(isWaitingReview())
  }, [])

  return (
    <Button
      id={id}
      startIcon={<FindInPage fontSize="small"></FindInPage>}
      style={{
        borderColor: waitingReview ? Colors.darkBlue : '#ddd',
        backgroundColor: waitingReview ? Colors.blue : Colors.white,
        color: waitingReview ? Colors.white : '#676767',
      }}
      onClick={onClick}
    >
      <FindInPage style={{ fontSize: '1.6rem' }} />

      <span id={id} style={{ fontSize: '1.3rem' }}>
        {waitingReview ? 'Analisar' : 'Detalhes'}
      </span>
      {waitingReview ? (
        <Notification>{notificationsNumber === 0 ? '.' : notificationsNumber}</Notification>
      ) : null}
    </Button>
  )
}

export default OpenApplicationButton
